import React, { useState, useEffect } from 'react'
import { Card, Col, Container, Form, Input, FormFeedback, Spinner } from 'reactstrap'
// Redux
import { withRouter, Link } from "react-router-dom"
// actions
import { getLabRequestSamples, addNewLabRequestSample, updateLabRequestSample, deleteLabRequestSample, getLabRequestSample } from "../../../store/labCitec/labRequestSamples/actions"
import { getLabRequestQuotes, addNewLabRequestQuote } from "../../../store/labCitec/labRequestQuotations/actions"
import { getQuotations } from "../../../store/catalogs/Quotations/actions"
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { getLabRequest } from "../../../store/labCitec/labRequest/actions"
import { getLabRequestAssignments } from "../../../store/labCitec/labRequestAssignments/actions"
import { ConfirmationModal } from '../../../components/Common/ConfirmationModal'
import { BackButton } from '../../../components/Common/BackButton'
import { SearchBar } from '../../../components/Common/SearchBar'
import { NewRegisterButton } from '../../../components/Common/NewRegisterButton'
import Table1 from "../../../components/Common/TableContainer"
import { Expander } from '../../../components/Common/Expander'
import moment from 'moment';
import * as Yup from "yup";
import { useFormik } from "formik";
import { statuses } from '../../../constants'
// import { AddModal } from './addModal'

const QuotationsTab = ({id, activeTab, generalStatus}) => {

  
  const dispatch = useDispatch();
  const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/

  const labRequestId = id

  const [showModal1, setShowModal1] = useState(false);
  const [subTotal, setSubTotal] = useState(0);
  const [totalCost, setTotalCost] = useState(0);
  const [ivaCost, setIvaCost] = useState(0);

  const numberFormatter = Intl.NumberFormat('en-US');

  useEffect(() => {
    dispatch(getLabRequestQuotes(`?limit=20&page=0&labRequest=${labRequestId}`))
    dispatch(getLabRequestAssignments(`?limit=100&page=&labRequest=${labRequestId}`))
    dispatch(getQuotations("?limit=20&page=0"))
  },[activeTab])

  const { loading, labRequest, total, currentPage,
    quotations, labRequestQuotes, labRequestAssignments
  } = useSelector(state => ({
    loading: state.labRequestSurveyQuotesReducer.loading,
    labRequest: state.labRequestReducer.labRequest,
    total: state.labRequestReducer.total,
    currentPage: state.labRequestReducer.currentPage,

    quotations: state.quotationsReducer.quotations,
    labRequestQuotes: state.labRequestSurveyQuotesReducer.labRequestQuotes,
    labRequestAssignments: state.labRequestAssignmentReducer.labRequestAssignments,
  }), shallowEqual);

  // Recalcular totales cada vez que cambien los datos de la cotización en Redux
  useEffect(() => {
    let tot = 0
    labRequestQuotes[0]?.labRequestQuotationTest?.forEach(element => {
      tot = tot + element.totalPrice
    });
    setSubTotal(tot)
    setIvaCost(tot * 0.16)
    setTotalCost(tot * 1.16)
  }, [labRequestQuotes])

  const reportValidationAssignment = labRequestAssignments?.find(
    x => x.statusAssignment?.toLowerCase() === 'validación de informes'
  );
  const reportValidationUser = reportValidationAssignment?.user;
  
  const reportValidationName = reportValidationUser
    ? `${reportValidationUser.name ?? ''} ${reportValidationUser.surname ?? ''}`.trim()
    : '';
  const reportValidationRole = reportValidationUser?.role ?? '';

  const technicalAdviserName = labRequest?.technicalAdviser
    ? `${labRequest.technicalAdviser.name ?? ''} ${labRequest.technicalAdviser.surname ?? ''}`.trim()
    : '';
  const technicalAdviserPhone = labRequest?.technicalAdviser?.phone ?? '';
  const technicalAdviserAddress = labRequest?.technicalAdviser?.address ?? '';

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      customer: labRequestQuotes[0]?.customer || technicalAdviserName,
      contactPhone: labRequestQuotes[0]?.contactPhone || technicalAdviserPhone,
      attention: labRequestQuotes[0]?.attention || reportValidationName,
      address: labRequestQuotes[0]?.address || technicalAdviserAddress,
      justification: labRequestQuotes[0]?.justification ?? 'De acuerdo con su amable solicitud, nos es grato presentarle con usted el siguiente presupuesto para realizar los ensayos de laboratorio, solicitados para:',
      quotationResponsible: labRequestQuotes[0]?.quotationResponsible || reportValidationName,
      quotationResponsiblePosition: labRequestQuotes[0]?.quotationResponsiblePosition || reportValidationRole,
    },
    validationSchema: Yup.object({
      justification: Yup.string().required("Justificación es un campo obligatorio"),
      contactPhone: Yup.string().matches(phoneRegExp, 'Ingrese numero teléfonico válido').required("Teléfono es un campo obligatorio"),
      customer: Yup.string().required("Cliente es un campo obligatorio"),
      address: Yup.string().required("Domicilio es un campo obligatorio"),
      attention: Yup.string().required("Campo obligatorio"),
      quotationResponsible: Yup.string().required("Campo obligatorio"),
      quotationResponsiblePosition: Yup.string().required("Campo obligatorio"),
    }),
    onSubmit: (values, { resetForm }) => {

      const updVal = {
        ...values,
        labRequest: labRequestId,
      }
      dispatch(addNewLabRequestQuote(updVal))
      // La saga se encarga de recargar los datos automáticamente después de crear.
    }
  });

  

  // console.log('Labrequest:',labRequest ?? '')

  const generateQuote = () =>{
    setShowModal1(true)
  }

  const onAcceptGeneratingQuote = () =>{
    validation.submitForm()
  }

  const getPagination = () =>{

  }

  const columns1 = React.useMemo(
    () => [
        // {
        //     Header: 'Partida',
        //     width: '23%',
        //     Cell: ({ row }) => (
        //       <div>
        //           <div className='text-start'>{row.original.labRequestQuotationTest ?? '-'}</div>
        //       </div>
        //     ),
        // },
        {
          Header: 'Norma',
          width: '23%',
          Cell: ({ row }) => (
            <div>
                <div className='text-start'>{row.original?.labRequestTest?.labTest?.norm?.name ?? '-'}</div>
            </div>
          ),
        },
        {
          Header: 'Ensayo',
          width: '23%',
          Cell: ({ row }) => (
            <div>
                <div className='text-start'>{row.original?.labRequestTest?.labTest?.name ?? '-'}</div>
            </div>
          ),
        },
        {
          Header: 'Cantidad',
          width: '12%',
          Cell: ({ row }) => (
            <div>
                <div className='text-right'>{` ${row.original?.quantity ?? '-'}`}</div>
            </div>
          ),
        },
        {
          Header: 'Precio Unitario',
          width: '12%',
          Cell: ({ row }) => (
            <div>
                <div className='text-right'>{`$ ${(row.original?.unitPrice).toLocaleString('en-US', {maximumFractionDigits:2}) ?? '-'}`}</div>
            </div>
          ),
        },
        {
          Header: 'Importe',
          width: '12%',
          Cell: ({ row }) => (
            <div>
                <div className='text-right'>{`$ ${(row.original?.totalPrice).toLocaleString('en-US', {maximumFractionDigits:2}) ?? '-'}`}</div>
            </div>
          ),
        },
        ],
        []
    )

  const columns2 = React.useMemo(
    () => [
        {
            Header: 'Notas',
            width: '100%',
            Cell: ({ row }) => (
              <div>
                  <div className='text-start'>{row.original.note ?? '-'}</div>
              </div>
            ),
        },
        ],
        []
    )

  

  return(
    <React.Fragment>
      {/* <div className="page-content"> */}
        <Container fluid className="p-0" >
          <h4 className='text-primary'><u>Presupuesto de Servicios</u></h4>
          <div className="page-title-box d-flex align-items-center justify-content-end">
            <div className='col-auto mx-1'>
              <button disabled={generalStatus != null} type='button' onClick={()=>{generateQuote()}} className="btn btn-success py-2 rounded-3" >
                <span className="mdi mdi-file-document me-2"></span>Crear Cotización
              </button>
            </div>
            <Link
              to={generalStatus != null || generalStatus === statuses.FINISHED || generalStatus === statuses.CANCELLED ? '#' : `/process-notification/${labRequestId}`}
              onClick={(e) => {
                if (generalStatus === statuses.FINISHED || generalStatus === statuses.CANCELLED) {
                  e.preventDefault(); // Prevent navigating
                }
              }}
            >
              <button
                type="button"
                disabled={generalStatus != null || generalStatus === statuses.FINISHED || generalStatus === statuses.CANCELLED}
                className="btn btn-success py-2 w-100 rounded-3"
              >
                <span className="mdi mdi-email me-2"></span>Notificar
              </button>
            </Link>

            <div className='col-auto mx-1'>
              <Link
                to={{
                  pathname: `/quotations/print/${labRequestId}`,
                }}
              >
                <button className="btn btn-success py-2 rounded-3" > <span className="mdi mdi-printer me-2"></span>Imprimir</button>
              </Link>
              {/* <button type='button' className="btn btn-success py-2 w-100 rounded-3" >
                <span className="mdi mdi-printer me-2"></span>Imprimir
              </button> */}
            </div>
            
          </div>
          <div className="row ml-2 mr-2 mb-2">
            <div className="col-3 col-md-4">
              <label className='text-primary'>Folio</label>
              <Input
                disabled
                name="code"
                value={labRequest?.code || ""}
              />
            </div>
          </div>
          <hr className='text-primary' />
          {
            loading ?
            <div className="text-center py-5">
              <Spinner
                color="primary"
              >
              </Spinner>
              <div className="row-center mt-2">
                {' '}Cargando...
              </div>
            </div> :
            <Form
              className="form-horizontal mt-3 mb-1"
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}
            >
              <div className='row'>
                <div className="row ml-2 mr-2 mb-2">
                  <div className="col-3 col-md-4">
                    <label className='text-primary'>Asunto</label>
                    <Input
                      disabled
                      name="code"
                      className="form-control text-primary"
                      placeholder="Código de Unidad de Medida"
                      type="text"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      // value={validation.values.code || ""}
                      value={'Cotización Ensayos de Laboratorio - CITEC'}
                    />
                  </div>
                  <div className="col-3 col-md-4">
                    <label className='text-primary ml-1'>Ciudad de México a:</label>
                    <div className='w-100 me-3'>
                      <Input 
                        disabled
                        required
                        name="startedAt"
                        className="form-control rounded-3 text-primary"
                        type='date'
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={moment().format('YYYY-MM-DD')}
                      />
                    </div>
                  </div>
                  <div className="col-3 col-md-4">
                    <label className='text-primary ml-1'>Estimado, cliente:</label>
                    <div className='w-100 me-3'>
                      <Input
                        // disabled
                        name="customer"
                        className="form-control text-primary"
                        placeholder="Nombre del cliente"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        // value={validation.values.code || ""}
                        value={validation.values.customer || ""}
                        invalid={
                          validation.touched.customer && validation.errors.customer ? true : false
                        }
                      />
                      {validation.touched.customer && validation.errors.customer ? (
                          <FormFeedback type="invalid">{validation.errors.customer}</FormFeedback>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
              <div className='row'>
                <div className="row ml-2 mr-2 mb-2">
                  <div className="col-3 col-md-4">
                    <label className='text-primary ml-1'>Empresa:</label>
                    <div className='w-100 me-3'>
                      <Input
                        disabled
                        // name="code"
                        className="form-control text-primary"
                        placeholder="Nombre del cliente"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        // value={validation.values.code || ""}
                        value={'Holcim México'}
                      />
                    </div>
                  </div>
                  <div className="col-3 col-md-4">
                    <label className='text-primary ml-1'>Teléfono de Contacto</label>
                    <div className='w-100 me-3'>
                      <Input
                          name="contactPhone"
                          className="form-control text-primary"
                          placeholder="Teléfono"
                          type="text"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.contactPhone || ""}
                          invalid={
                              validation.touched.contactPhone && validation.errors.contactPhone ? true : false
                          }
                      />
                      {validation.touched.contactPhone && validation.errors.contactPhone ? (
                          <FormFeedback type="invalid">{validation.errors.contactPhone}</FormFeedback>
                      ) : null}
                    </div>
                  </div>

                  <div className="col-3 col-md-4">
                    <label className='text-primary ml-1'>Atentamente:</label>
                    <div className='w-100 me-3'>
                      <Input
                        // disabled
                        name="attention"
                        className="form-control text-primary"
                        placeholder=""
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        // value={validation.values.code || ""}
                        value={validation.values.attention || ""}
                        invalid={
                          validation.touched.attention && validation.errors.attention ? true : false
                        }
                      />
                      {validation.touched.attention && validation.errors.attention ? (
                          <FormFeedback type="invalid">{validation.errors.attention}</FormFeedback>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>

              <div className='row'>
                <div className="row ml-2 mr-2 mb-2">
                  <div className="col-3 col-md-4">
                    <label className='text-primary ml-1'>Segmento:</label>
                    <div className='w-100 me-3'>
                      <Input
                        disabled
                        // name="code"
                        className="form-control text-primary"
                        placeholder="Nombre del cliente"
                        type="text"
                        // value={validation.values.code || ""}
                        value={labRequest?.laboratorySegment?.name || ''}
                      />
                    </div>
                  </div>
                  <div className="col-3 col-md-8">
                    <label className='text-primary ml-1'>Domicilio</label>
                    <div className='w-100 me-3'>
                      <Input
                          name="address"
                          className="form-control text-primary"
                          placeholder="Domicilio"
                          type="text"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.address || ""}
                          invalid={
                              validation.touched.address && validation.errors.address ? true : false
                          }
                      />
                      {validation.touched.address && validation.errors.address ? (
                          <FormFeedback type="invalid">{validation.errors.address}</FormFeedback>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>

              <div className='row'>
                <div className="row ml-2 mr-2 mt-2">
                  <div className="col-3 col-md-12">
                    <div className='w-100 me-3'>
                      <Input
                        // disabled
                        name="justification"
                        className="form-control text-primary"
                        // placeholder="Nombre del cliente"
                        type='textarea'
                        // value={validation.values.code || ""}
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.justification || ''}
                        invalid={
                          validation.touched.justification && validation.errors.justification ? true : false
                        }
                      />
                      {validation.touched.justification && validation.errors.justification ? (
                          <FormFeedback type="invalid">{validation.errors.justification}</FormFeedback>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            
            
              <h4 className='text-primary mt-3'><u>Detalle de la Cotización</u></h4>
              <div className='mt-2'>
                <Table1 loading={loading} currentPage={currentPage} getPagination={getPagination} total={total} isAddTableBorderStrap columns={columns1} data={labRequestQuotes[0]?.labRequestQuotationTest ?? []} />
              </div>
              <div className="mt-3 d-flex align-items-center justify-content-end mb-2 mt-0">
                  <div className="px-3 py-1 mx-3 col-3 col-md-1" style={{backgroundColor:'#1D4370', color:'white', alignContent:'center', alignItems:'center', textAlign:'center', fontSize:16}}>
                    <div>Subtotal</div>
                  </div>
                  <div className="text-center py-1 col-3 col-md-1" style={{backgroundColor:'#1D4370', color:'white', alignContent:'center', alignItems:'center', textAlign:'center', fontSize:16}}>
                  <div>{  `$ ${(subTotal).toLocaleString('en-US', {maximumFractionDigits:2})}` }</div>
                  </div>
              </div>
              <div className="d-flex align-items-center justify-content-end my-2">
                  <div className="py-1 px-3 mx-3 col-3 col-md-1" style={{backgroundColor:'#1D4370', color:'white', alignContent:'center', alignItems:'center', textAlign:'center', fontSize:16}}>
                    <div>16% de IVA</div>
                  </div>
                  <div className="py-1 text-center col-3 col-md-1" style={{backgroundColor:'#1D4370', color:'white', alignContent:'center', alignItems:'center', textAlign:'center', fontSize:16}}>
                  <div>{  `$ ${(ivaCost).toLocaleString('en-US', {maximumFractionDigits:2})}` }</div>
                  </div>
              </div>
              <div className="d-flex align-items-center justify-content-end mt-2">
                  <div className="py-1 px-3 mx-3 col-3 col-md-1" style={{backgroundColor:'#1D4370', color:'white', alignContent:'center', alignItems:'center', textAlign:'center', fontSize:16}}>
                    <div>Total</div>
                  </div>
                  <div className="py-1 text-center col-3 col-md-1" style={{backgroundColor:'#1D4370', color:'white', alignContent:'center', alignItems:'center', textAlign:'center', fontSize:16}}>
                  <div>{  `$ ${(totalCost).toLocaleString('en-US', {maximumFractionDigits:2})}` }</div>
                  </div>
              </div>

              <div className='mt-2'>
                <Table1 loading={loading} currentPage={currentPage} getPagination={getPagination} total={total} isAddTableBorderStrap columns={columns2} data={quotations} />
              </div>
              
              
              <div className='row'>
                <div className="row ml-2 mr-2 mb-2">
                  <div className="col-3 col-md-6">
                    <label className='text-primary ml-1'>Nombre:</label>
                    <div className='w-100 me-3'>
                      <Input
                        // disabled
                        name="quotationResponsible"
                        className="form-control text-primary"
                        placeholder="Nombre"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.quotationResponsible || ""}
                        invalid={
                          validation.touched.quotationResponsible && validation.errors.quotationResponsible ? true : false
                        }
                      />
                      {validation.touched.quotationResponsible && validation.errors.quotationResponsible ? (
                          <FormFeedback type="invalid">{validation.errors.quotationResponsible}</FormFeedback>
                      ) : null}
                    </div>
                  </div>
                  <div className="col-3 col-md-6">
                    <label className='text-primary ml-1'>Puesto:</label>
                    <div className='w-100 me-3'>
                      <Input
                          name="quotationResponsiblePosition"
                          className="form-control text-primary"
                          placeholder="Puesto"
                          type="text"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.quotationResponsiblePosition || ""}
                          invalid={
                              validation.touched.quotationResponsiblePosition && validation.errors.quotationResponsiblePosition ? true : false
                          }
                      />
                      {validation.touched.quotationResponsiblePosition && validation.errors.quotationResponsiblePosition ? (
                          <FormFeedback type="invalid">{validation.errors.quotationResponsiblePosition}</FormFeedback>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </Form>
          }

          <ConfirmationModal
            message="¿Está seguro de generar la cotización para esta solicitud?"
            showModal={showModal1}
            setShowModal={setShowModal1}
            onAccept={onAcceptGeneratingQuote}
          />
        </Container>
      {/* </div> */}
    </React.Fragment>
  )

}

export default withRouter(QuotationsTab)